import columnListBlock from '../column-list-block';

columnListBlock.init('events-shows-teaser-band-block');